/* Presentation adapter. No calculation, storage, network or form-submission logic. */
const installed = new WeakSet();

function mountResults(root) {
  if (installed.has(root)) return;
  const copyNode = root.querySelector('[data-fea-star-copy]');
  let copy;
  try { copy = JSON.parse(copyNode?.textContent || '{}'); } catch { return; }
  installed.add(root);

  const starSource = root.querySelector('[data-fea-ziwei]');
  const colorsSource = root.querySelector('[data-fea-colors]');
  const grid = root.querySelector('[data-fea-product-grid]');
  const summary = root.querySelector('[data-fea-result-summary]');
  const beneficial = root.querySelector('[data-fea-result-beneficial]');
  const empty = root.querySelector('[data-fea-result-empty]');

  const renderSummary = () => {
    if (!summary) return;
    const label = (starSource?.textContent || '').trim();
    const traditionalFailure = document.documentElement.lang === 'zh-TW' && label === '紫微计算暂不可用。';
    const known = traditionalFailure ? [] : Object.entries(copy)
      .map(([key, value]) => ({ ...value, position: Math.max(label.indexOf(key), label.indexOf(value.heading)) }))
      .filter(star => star.position >= 0)
      .sort((a, b) => a.position - b.position);
    const rows = known.length ? known : [{
      heading: traditionalFailure ? '星曜概況暫未提供' : /unavailable|失败/.test(label) ? 'Star profile unavailable' : 'Your symbolic profile',
      description: traditionalFailure ? '紫微計算暫未提供。' : label || 'Your assessment results will appear here.',
    }];
    summary.replaceChildren(...rows.map(star => {
      const article = document.createElement('article');
      article.className = 'ser-star';
      const heading = document.createElement('h2');
      const description = document.createElement('p');
      heading.textContent = star.heading;
      description.textContent = star.description;
      article.append(heading, description);
      return article;
    }));
  };

  const renderBeneficial = () => {
    if (!beneficial) return;
    const names = [...(colorsSource?.querySelectorAll('li') || [])]
      .map(item => item.textContent.trim()).filter(Boolean);
    beneficial.textContent = names.join(' · ') || 'Not available';
  };

  const decorateProducts = () => {
    if (!grid) return;
    const cards = grid.querySelectorAll('.fea__product-card');
    cards.forEach(card => {
      if (!card.querySelector('.ser-product-action')) {
        const action = document.createElement('span');
        action.className = 'ser-product-action';
        action.textContent = 'View details';
        card.append(action);
      }
    });
    // Only the Element to Balance color matches are presented as recommendations.
    const hasMatches = cards.length > 0;
    if (empty) empty.hidden = hasMatches;
  };

  const observers = [];
  const observe = (target, callback, options) => {
    if (!target) return;
    const observer = new MutationObserver(callback);
    observer.observe(target, options);
    observers.push(observer);
  };
  observe(starSource, renderSummary, { childList: true, characterData: true, subtree: true });
  observe(colorsSource, renderBeneficial, { childList: true, characterData: true, subtree: true });
  observe(grid, decorateProducts, { childList: true });
  renderSummary();
  renderBeneficial();
  decorateProducts();
  root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
    observers.forEach(observer => observer.disconnect());
    installed.delete(root);
  }, { once: true });
}

function mountWithin(scope) {
  if (scope.matches?.('.fea--reference')) mountResults(scope);
  scope.querySelectorAll?.('.fea--reference').forEach(mountResults);
}
mountWithin(document);
document.addEventListener('shopify:section:load', event => mountWithin(event.target));
